import { useCall } from "../state/CallProvider";
import type { HistoryEntry } from "../telephony/types";
import { IconHangup, IconIncoming, IconPhone } from "./icons";

function when(ms: number): string {
  const d = new Date(ms);
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  return sameDay
    ? d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
function dur(s: number): string {
  if (!s) return "—";
  const m = Math.floor(s / 60);
  return m ? `${m}m ${s % 60}s` : `${s}s`;
}

export function CallList({ entries }: { entries: HistoryEntry[] }) {
  const { dial } = useCall();
  if (entries.length === 0) return <div className="list-empty">No calls yet.</div>;
  return (
    <div className="list">
      {entries.map((e) => {
        const missed = e.outcome === "missed" || e.outcome === "abandoned";
        const cls = missed ? "missed" : e.direction === "inbound" ? "inbound" : "";
        return (
          <div key={e.id + e.startedAtMs} className="li" onClick={() => void dial(e.contact)} title="Call back">
            <span className={"li-ic " + cls}>
              {missed ? <IconHangup size={15} /> : e.direction === "inbound" ? <IconIncoming size={15} /> : <IconPhone size={15} />}
            </span>
            <div className="li-main">
              <div className="li-name">{e.contact.name ?? e.contact.number}</div>
              <div className="li-sub">{e.contact.name ? e.contact.number : `${e.direction} · ${e.outcome}`}</div>
            </div>
            <div className="li-time">{when(e.startedAtMs)}<br />{dur(e.durationSec)}</div>
          </div>
        );
      })}
    </div>
  );
}
